import React from 'react';
import { Typography, Form, Input, Row, Col } from 'antd';
import { useNavigate, Link } from 'react-router-dom';
import { RESET_PASSWORD } from 'src/graphql';
import { useMutation } from '@apollo/client';
import { errorMessage, successMessage } from 'src/utils/Notifications';
import { AuthImageHeader, PrimaryButton } from '../components';

const { Title, Text } = Typography;
const FormItem = Form.Item;

type FormValues = {
    email?: string;
};

function ForgotPassword(): React.ReactElement {
    const navigate = useNavigate();
    const [resetPasword, { loading }] = useMutation(RESET_PASSWORD);
    const handleResetPassword = (values: FormValues) => {
        const { email } = values;
        resetPasword({
            variables: {
                email,
            },
        })
            .then(() => {
                successMessage('Password reset secret key sent via EmailAddress');
                navigate('/');
            })
            .catch(() => {
                errorMessage('Password reset failed');
            });
    };
    return (
        <div className="webkit-center">
            <AuthImageHeader
                  topText="Reset"
                  pageTile="Password"
                  breadCrumb=""
            />
             <Row justify="center" style={{marginBottom: "30px"}}>
                <Col xs={{span: 22}} sm={{span: 20 }} md={{span: 18 }} lg={{ span: 16 }} xl={{  span: 10 }} xxl={{ span: 10 }}>
                    <div className="auth-form" style={{marginTop:"30px"}}>
                <Form className="margin-y-xl" onFinish={handleResetPassword}>
                    <Row>
                        <Text style={{color:"#0C6A54", textAlign:"left", fontWeight:"bold"}} className="margin-bottom-md margin-left-sm float-left">
                            Please enter your email
                        </Text>
                    </Row>
                    <FormItem name="email" style={{marginBottom:"4px"}}>
                        <Input placeholder="Email" type="email" style={{borderWidth:"1px", borderColor:"#EE773B", borderRadius:"50px"}} />
                    </FormItem>
                    <Row>
                        <Col span={12}> 
                          <Link to="/">
                            <Title level={5} className="auth-link" style={{textAlign:"left"}}>
                            Back to login
                            </Title>
                        </Link>
                        </Col>

                    </Row>
                    <div style={{marginTop:"10px", width:"100%", textAlign:"center", alignContent:"center", alignItems:"center", height:"50px"}}>
                      <PrimaryButton title="Reset" htmlType="submit" loading={loading} styles={{backgroundColor: "#EE773B", borderRadius:"20px", textAlign:"center", lineHeight:"25px", fontSize: "16px", height:"32px", width:"100px", padding:"0px"}} />
                    </div>
                  </Form>
                </div>
              </Col>
             </Row>
            </div>
    );
}

export default ForgotPassword;
